// Local selectors for open additional account :
import { createStructuredSelector } from 'reselect';
import { selectAdditionalAccountDetails } from "../../../Messaging/selectors";
import { selectCsrBusinessFunction, navBarData } from "../../../../selectors/globalSelectors";

// fetching makeAContributionReducer
export const fetchLocalReducer = (store) => store.makeAContribution;

// fetching API Data from reducer
export const fetchApiData = (state) => {
    const { apiData } = fetchLocalReducer(state);
	return apiData;
};

// select additional details from API Data
export const selectAdditionalDetails = (state) => {
    const { additionalDetails } = fetchApiData(state);
    return additionalDetails.data ? additionalDetails.data : {};
};

export const getDummyData = (state) => {
    const { dummyUpdate } = fetchApiData(state);
    return dummyUpdate;
};

export const getDrupalData = (state) => {
    const { drupalData } = fetchApiData(state);
    return drupalData.data;
};

export const checkAPICalled = (state) => {
    const { isAPICalled } = fetchApiData(state);
    return isAPICalled;
};

export const fetchDropdownData = (state) => {
    const { dropdownData } = fetchApiData(state);
    return dropdownData.data;
}

export const selectContributionTypes = (state) => {
    const { contributionTypes } = fetchLocalReducer(state);
    return contributionTypes;
};

export const fetchAllocationData = (state) => {
    const { contributionAllocation } = fetchLocalReducer(state);
    return contributionAllocation;
};

export const fetchAllocationFormData = (state) => {
    const { form } = fetchAllocationData(state);
    return form;
};

export const fetchAllocationApiSuccess = (state) => {
    const { isApiSuccess } = fetchAllocationData(state);
    return isApiSuccess;
}

export const selectAllocationPreference = (state) => {
    const { allocationPreference } = fetchAllocationData(state);
    return allocationPreference;
};

export const fetchFundDetails = (state) => {
    const { tickerValues } = fetchApiData(state);
    return tickerValues ? tickerValues.data : [];
};

export const selectBusinessDate = (state) => {
    const { lastBusinessDate } = fetchAllocationData(state);
    return lastBusinessDate;
};

export const fetchAllocationTotal = (state) => {
    const { total } = fetchAllocationData(state);
    return total;
};

export const fetchDefaultAllocation = (state) => {
    const { defaultAllocation } = fetchAllocationData(state);
    return defaultAllocation; 
}

export const fetchRecordedValue = (state) => {
    const { recordedVal } = fetchAllocationData(state);
    return recordedVal;
}

export const fetchAllocationDummydata = (state) => {
    const { dummyUpdate } = fetchAllocationData(state);
    return dummyUpdate;
}

export const postSuccessData = (state) => {
    const { successData } = fetchApiData(state);
    return successData;
};

export const selectIsEdit = (state) => {
     const { isEdit } = selectContributionTypes(state);
     return isEdit;
};

export const selectStep2IsEdit = (state) => {
    const { isEdit } = fetchAllocationData(state);
    return isEdit;
};

export const selectContributionStatus = (state) => {
    const { contributionStatus } = fetchLocalReducer(state);
    return contributionStatus.data;
};

export const selectContributeTypeConfigData = (state) => {
    const { contributeTypeConfig } = fetchLocalReducer(state);
    return contributeTypeConfig;
};

export const selectContributeTypeConfig = (state) => {
    const { data } = selectContributeTypeConfigData(state);
    return data;
};

export const selectAlertData = (state) => {
    const { alertData } = selectContributeTypeConfigData(state);
    return alertData;
};

export const selectPageDetails = (state) => {
    const { pageDetails } = selectContributeTypeConfigData(state);
    return pageDetails;
};

export const selectFundGifts = (state) => {
    const { fundDetails } = fetchApiData(state);
    return fundDetails.data && fundDetails.data.fundGifts;
};

export const selectIsDataEditedStep1 = (state) => {
    const { isDataEdit } = selectContributionTypes(state);
    return isDataEdit;
};

export const selectIsDataEditedStep2 = (state) => {
    const { isDataEdit } = fetchAllocationData(state);
    return isDataEdit;
};

export const selectInitialContributionData = (state) => {
    const { isInitialContribution } = fetchAllocationData(state);
    return isInitialContribution;
};

export const selectAssetHeldVGData = (state) => {
    const { assetHeldatVG } = selectContributionTypes(state);
    return assetHeldatVG;
};

export const selectAssetOutsideVGData = (state) => {
    const { assetOutsideVG } = selectContributionTypes(state);
    return assetOutsideVG;
};

export const selectCheckList = (state) => {
    const { checkOrEBT } = selectContributionTypes(state);
    return checkOrEBT.checkEBTList;
};

export const selectStockCertificateList = (state) => {
    const { stockCertificate } = selectContributionTypes(state);
    return stockCertificate.stockCertificateList;
};

export const selectWireList = (state) => {
    const { wire } = selectContributionTypes(state);
    return wire.wireList;
};

export const selectAssetHeldVGmutualFund = (state) => {
    const { mutualFund } = selectAssetHeldVGData(state);
    return mutualFund;
};

export const selectAssetHeldVGsecurityGift = (state) => {
    const { securityGift } = selectAssetHeldVGData(state);
    return securityGift;
};

export const selectAssetHeldVGmfSelected = (state) => {
    const { mfSelected } = selectAssetHeldVGData(state);
    return mfSelected;
};

export const selectAssetHeldVGsgSelected = (state) => {
    const { sgSelected } = selectAssetHeldVGData(state);
    return sgSelected;
};

export const selectAssetHeldVGaccessSelected = (state) => {
    const { accessSelected } = selectAssetHeldVGData(state);
    return accessSelected;
};

export const selectAccessKeyData = (state) => {
    const { accessKeyData } = fetchLocalReducer(state);
    return accessKeyData.data;
};

export const selectLoggedInAddress = (state) => {
    const { loggedInAddress } = fetchApiData(state);
    return loggedInAddress ? loggedInAddress.data : {};
};

export const selectAccessKeyGeneratedAndActive = (state) => {
    const { accessKeyGeneratedAndActive = null } = selectAdditionalDetails(state);
    return accessKeyGeneratedAndActive;
};

export const selectAccessKeyLinked = (state) => {
    const { accessKeyLinked = null } = selectAdditionalDetails(state);
    return accessKeyLinked;
};

export const fetchKeySuccess = (state) => {
    const { isAccessKeySuccess = null } = selectContributionTypes(state);
    return isAccessKeySuccess;
};

export const selectAssetOutsideVGmutualFund = (state) => {
    const { mutualFund } = selectAssetOutsideVGData(state);
    return mutualFund;
};

export const selectAssetOutsideVGsecurityGift = (state) => {
    const { securityGift } = selectAssetOutsideVGData(state);
    return securityGift;
};

export const selectAssetOutsideVGmfSelected = (state) => {
    const { mfSelected } = selectAssetOutsideVGData(state);
    return mfSelected;
};

export const selectAssetOutsideVGsgSelected = (state) => {
    const { sgSelected } = selectAssetOutsideVGData(state);
    return sgSelected;
};


export const fetchAutoCompleteValue = (state, ownProps) => {
    const { assetHeld, contributionType, accountId, fundType, inputId, property } = ownProps;
    const { contributionTypes } = selectContributionTypes(state);
    const selectAssetHeld = contributionTypes[assetHeld];
    const selectContribType = selectAssetHeld[contributionType];
    const selectAccountId = selectContribType[accountId];
    const selectFundType = selectAccountId[fundType];
    const selectInputId = selectFundType[inputId];
    const selectProperty = selectInputId[property];
    return selectProperty;
};

// MainPage
export const macMainPageState =  createStructuredSelector({
  additionalDetails: selectAdditionalAccountDetails,
  additionalAccountDetails: selectAdditionalDetails,
  isDummyUpdated: getDummyData,
  drupalData: getDrupalData,
  isAPICalled: checkAPICalled,
  contributionDetails: selectContributionTypes,
  allocationData: fetchAllocationFormData,
  allocationPreference: selectAllocationPreference
});

// Auto Complete
export const autoCompleteStateState =  createStructuredSelector({
    fundDetails : fetchFundDetails,
    value: fetchAutoCompleteValue,
});

// Contribution Confirmation
export const contributionConfirmationState =  createStructuredSelector({
    drupalData: getDrupalData,
    lastBusinessDate: selectBusinessDate,
});

// Confirmation processing Details
export const confirmationProcessingDetailsState =  createStructuredSelector({
    successData: postSuccessData
});

//Contribution Type Main
export const contributionTypeState =  createStructuredSelector({
    contributionDetails: selectContributionTypes,
    isEditClicked: selectIsEdit,
    contributionStatus: selectContributionStatus,
    contributeTypeConfig: selectContributeTypeConfig,
    alertData: selectAlertData,
    pageDetails: selectPageDetails,
    fundDetails: selectFundGifts,
    isEdit: selectIsDataEditedStep1,
    isAPICalled: checkAPICalled,
    isInitialContribution: selectInitialContributionData
});

//Asset held at Vanguard
export const assetHeldAtVanguardState =  createStructuredSelector({
    mfAccountDetails: selectAssetHeldVGmutualFund,
    sgAccountDetails: selectAssetHeldVGsecurityGift,
    isVGselected: selectAssetHeldVGmfSelected,
    isSGselected: selectAssetHeldVGsgSelected,
    accessSelected: selectAssetHeldVGaccessSelected,
    accessKey: selectAccessKeyData,
    loggedInAddress: selectLoggedInAddress,
    csrBusinessFunction: selectCsrBusinessFunction,
    navBarData: navBarData,    
    accessKeyGenerated : selectAccessKeyGeneratedAndActive,
    accessKeyLinked: selectAccessKeyLinked,
    isAccessKeySuccess: fetchKeySuccess,
    pageDetails: selectPageDetails
});

//Asset held outside Vanguard
export const assetHeldOutsideVanguardState =  createStructuredSelector({
    mfAccountDetails: selectAssetOutsideVGmutualFund,
    sgAccountDetails: selectAssetOutsideVGsecurityGift,
    isVGselected: selectAssetOutsideVGmfSelected,
    isSGselected: selectAssetOutsideVGsgSelected,
    loggedInAddress: selectLoggedInAddress
});

// Check
export const checkorEBTState =  createStructuredSelector({
    checkDetails: selectCheckList,    
    loggedInAddress: selectLoggedInAddress,
    pageDetails: selectPageDetails
});

// Stock Certificate
export const stockCertificateState =  createStructuredSelector({
    stockCertificateDetails: selectStockCertificateList,    
    loggedInAddress: selectLoggedInAddress
});

// Wire
export const wireState =  createStructuredSelector({
    wireDetails: selectWireList,    
    loggedInAddress: selectLoggedInAddress,
    pageDetails: selectPageDetails,
});

// Funding Instructions
export const fundingInstructionsState =  createStructuredSelector({
    data: postSuccessData
});

// Funding instructions LOA Docs
export const fundingInstructionsLOAState =  createStructuredSelector({
    contributionTypes: selectContributionTypes,
    allocationData: fetchAllocationFormData,
    drupalData: getDrupalData,
    successData: postSuccessData
});

// Wiring instructions
export const wiringInstructionsState =  createStructuredSelector({
    drupalData: getDrupalData
});

// Investment Options
export const investmentOptionsState =  createStructuredSelector({
    totalValue: fetchAllocationTotal,
    dummyData: fetchAllocationDummydata,
    reducerData: fetchAllocationData,
    alertData: selectAlertData,
    isEditClicked: selectStep2IsEdit,
    lastBusinessDate: selectBusinessDate,
    isEdit: selectIsDataEditedStep2,
    isApiSuccess: fetchAllocationApiSuccess
});

// Investment Allocation card
export const investmentAllocationCardState =  createStructuredSelector({
    accountData: fetchDefaultAllocation,
    dummyData: fetchAllocationDummydata,
    totalValue: fetchAllocationTotal,
});

// Invesment table step 2
export const investmentTableState =  createStructuredSelector({
    exchangeType: selectAllocationPreference,
    accountData: fetchDefaultAllocation,
    totalValue: fetchAllocationTotal,
    recordedValue: fetchRecordedValue,
    dummyData: fetchAllocationDummydata,
    lastBusinessDate: selectBusinessDate
});

// investment Preference step 2
export const investmentPreferenceState =  createStructuredSelector({
    accountData: fetchDefaultAllocation,
    grantAllocationDropdown: selectAllocationPreference,
    grantAllocation: fetchAllocationData,
    dummyData: fetchAllocationDummydata,
    isInitialContrib: selectInitialContributionData
});

// Review contribution and submit
export const reviewContributionAndSubmitState =  createStructuredSelector({
    totalValue: fetchAllocationTotal,
    defaultAllocationData: fetchDefaultAllocation,
    modifiedAllocationData: fetchAllocationFormData,
    lastBusinessDate: selectBusinessDate,
    contributionTypes: selectContributionTypes,
    alertData: selectAlertData,
    dropdownVal : fetchDropdownData,
    isApiSuccess: postSuccessData,
    dummyData: fetchAllocationDummydata,
    drupalData: getDrupalData
});

// step 3 contribution Type
export const contributionTypeStep3State =  createStructuredSelector({
    contributionTypes: selectContributionTypes
});

// step 3 Investment allocation card
export const investmentAllocationCardStep3State =  createStructuredSelector({
    accountData: fetchDefaultAllocation,
    formData: fetchAllocationFormData
})

// step 3 investment table
export const investmentTableStep3State =  createStructuredSelector({
    accountData: fetchDefaultAllocation
});

// step 3 allocation
export const allocationStep3State =  createStructuredSelector({
    data: fetchDefaultAllocation,
    poolData: fetchAllocationFormData,
    lastBusinessDate: selectBusinessDate
})